package pl.mothdigital.neuronowi.common.resources

import pl.mothdigital.neuronowi.common.model.*

object ImageResources {
    val navHeaderLogo = ImageResource(
        src = "/nav_header_logo.png",
        description = "${StringResources.APP_NAME} logo"
    )

    val homeHeroSectionImage = ImageResource(
        src = "/hero_section.webp",
        description = StringResources.HERO_SECTION_IMAGE_ALT,
        aspectRatio = "3/2"
    )

    val homeAboutSectionImage = ImageResource(
        src = "/about_section.webp",
        description = StringResources.ABOUT_SECTION_IMAGE_ALT,
        aspectRatio = "3/2"
    )

    val teamSectionImage = ImageResource(
        src = "/team_section.webp",
        description = "Zespół specjalistów Centrum NeuroNowi",
        aspectRatio = "3/2"
    )

    val avatarMagdalenaNowik = ImageResource(
        src = "/avatar_magda_nowik.webp",
        description = StringResources.MAGDALENA_NOWIK,
        aspectRatio = "1/1"
    )

    val avatarZaklinaWykret = ImageResource(
        src = "/avatar_zaklina_wykret.webp",
        description = StringResources.ZAKLINA_WYKRET,
        aspectRatio = "1/1"
    )

    val avatarEwaSofinska = ImageResource(
        src = "/avatar_ewa_sofinska.webp",
        description = StringResources.EWA_SOFINSKA,
        aspectRatio = "1/1"
    )

    val avatarMartaDybalska = ImageResource(
        src = "/avatar_marta_dybalska.webp",
        description = StringResources.MARTA_DYBALSKA,
        aspectRatio = "1/1"
    )

    val avatarRadoslawNitschke = ImageResource(
        src = "/avatar_radoslaw_nitschke.webp",
        description = StringResources.RADOSLAW_NITSCHKE,
        aspectRatio = "1/1"
    )

    val avatarPaulinaKonieczna = ImageResource(
        src = "/avatar_paulina_konieczna.webp",
        description = StringResources.PAULINA_KONIECZNA,
        aspectRatio = "1/1"
    )

    val avatarJuliaSiuta = ImageResource(
        src = "/avatar_julia_siuta.webp",
        description = StringResources.JULIA_SIUTA,
        aspectRatio = "1/1"
    )

    val avatarPatrycjaOchryniuk = ImageResource(
        src = "/avatar_patrycja_ochryniuk.webp",
        description = StringResources.PATRYCJA_OCHRYNIUK,
        aspectRatio = "1/1"
    )

    val avatarAnnaPetrus = ImageResource(
        src = "/avatar_anna_petrus.webp",
        description = StringResources.ANNA_PETRUS,
        aspectRatio = "1/1"
    )

    val avatarMagdalenaBanach = ImageResource(
        src = "/avatar_magdalena_banach.webp",
        description = StringResources.MAGDALENA_BANACH,
        aspectRatio = "1/1"
    )
}
